export default {
    GET_SIGNATURES: state => state.signatures,
    GET_SIGNATURE:  state => state.signature,
    GET_LOADING:    state => state.loading,
}
